// ** Initial State
const initialState = {
  data: [],
  userData: [],
  paginationMeta: {
    page: 1,
    pageSize: 20,
    total: 0,
    totalPages: 0,
  },
};

const transactions = (state = initialState, action) => {
  switch (action.type) {
  case 'GET_ADMIN_TRANSACTIONS':
    return {
      ...state,
      data: action.data.data,
      paginationMeta: {
        page: action.data.page,
        pageSize: action.data.pageSize,
        total: action.data.total,
        totalPages: action.data.totalPages,
      },
    };

  case 'GET_USER_TRANSACTIONS':
    return {
      ...state,
      userData: action.data.data,
      paginationMeta: {
        page: action.data.page,
        pageSize: action.data.pageSize,
        total: action.data.total,
        totalPages: action.data.totalPages,
      },
    };
  default:
    return { ...state };
  }
};
export default transactions;
